import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { formatMoneda } from "@/util/varios";
import moment from "moment";
import axios from "axios";
import CatalogoTipoMulta from "./caalogoTipoMulta";
import { Mensaje } from "@/components/mensajes2";
import { Dimmer } from "@/components/spinner";
export default function Multas(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
  const [titulo, setTitulo] = useState("Incluir");
  const [loading, setLoading] = useState(false);
  const [tipo, setTipo] = useState("comercio");
  const [idContribuyente, setIdContribuyente] = useState();
  const [showCatalogo, setShowCatalogo] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    idMulta: "",
    codigo: "",
    ordenanza: "",
    descripcion: "",
    concepto: "",
    fecha: moment().format("YYYY-MM-DD"),
    unitario: 0,
    total: 0,
    tipoImpuesto: "",
  });

  const validarOperacion = () => {
    switch (props.operacion) {
      case 1:
        registrarMulta();
        break;
      case 3:
        actualizarMulta();
        break;
      case 4:
        eliminarMulta();
        break;
    }
  };
  const registrarMulta = () => {
    const tablaContribuyente =
      tipo === "comercio" ? "comercio" : tipo === "licores" ? "licores" : "";

    setLoading(true);
    const endpoint = `${op.conexion}/api/gestion_comercial/registrar_multa`;
    axios
      .post(
        endpoint,
        {
          fechaMulta: body.fecha,
          idTipoMulta: body.codigo,
          descripcion: body.descripcion,
          concepto: body.concepto,
          valor: body.unitario,
          monto: body.total,
          idContribuyente: idContribuyente,
          tablaContribuyente: tablaContribuyente,
          tipoImpuesto: body.tipoImpuesto,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setMensaje({
            mostrar: true,
            texto: "Multa Creada Exitosamente",
            icono: "exito",
          });
          salir();
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Crear la Multa",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const actualizarMulta = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/gestion_comercial/actualizar_multa`;
    axios
      .patch(
        endpoint,
        {
          idMulta: body.idMulta,
          concepto: body.concepto,
          idTipoMulta: body.codigo,
          valor: body.unitario,
          monto: body.total,
          descripcion: body.descripcion,
          tipoImpuesto: body.tipoImpuesto,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setMensaje({
            mostrar: true,
            texto: "Multa Actualizada Exitosamente",
            icono: "exito",
          });
          salir();
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Actualizar la Multa",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const eliminarMulta = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/gestion_comercial/eliminar_multa?idMulta=${body.idMulta}`;
    axios
      .delete(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setMensaje({
            mostrar: true,
            texto: "Multa Eliminada Exitosamente",
            icono: "exito",
          });
          salir();
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Eliminar la Multa",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const seleccionarTipoMulta = (e) => {
    setBody((prev) => ({
      ...prev,
      codigo: e.idtipomulta,
      ordenanza: e.codigomulta,
      descripcion: e.descripcion,
      unitario: e.valor,
      total: parseFloat(e.valor) * parseFloat(factorCambio?.valor),
      tipoImpuesto: e.tipoimpuesto,
    }));
    setShowCatalogo(false);
  };
  const blanquear = () => {
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setBody({
      idMulta: "",
      codigo: "",
      ordenanza: "",
      descripcion: "",
      concepto: "",
      fecha: moment().format("YYYY-MM-DD"),
      unitario: 0,
      total: 0,
      tipoImpuesto: "",
    });
  };
  const salir = () => {
    blanquear();
    props.refrescarTabla();
    props.onHide();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTipo(props.tipo);
        setIdContribuyente(props.idContribuyente);
        if (props.operacion > 1 && props.multa) {
          const { multa } = props;
          setBody({
            idMulta: multa.id,
            codigo: multa.idTipoMulta,
            ordenanza: multa.codigoMulta,
            descripcion: multa.descripcion,
            concepto: multa.concepto,
            fecha: moment(multa.fecha).format("YYYY-MM-DD"),
            unitario: multa.valor,
            total: multa.monto,
            tipoImpuesto: multa.tipoImpuesto,
          });
        }
        switch (props.operacion) {
          case 2:
            setTitulo("Ver");
            break;
          case 3:
            setTitulo("Modificar");
            break;
          case 4:
            setTitulo("Eliminar");
            break;
          default:
            setTitulo("Incluir");
            break;
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">{titulo} Multa</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12">
          <fieldset className="row border-azul rounded mx-auto col-sm-12 mb-2">
            <legend className="float-none m-0 w-auto">Multa</legend>
            <div className="col-md-12 d-flex justify-content-bettween">
              <div className="input-group input-group-sm mb-1 col-md-6">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Código:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={body.codigo}
                  disabled
                />
                <button
                  style={{ textAlign: "center", color: "white" }}
                  className="btn btn-sm btn-info"
                  disabled={props.operacion === 4 || props.operacion === 2}
                  onClick={() => setShowCatalogo(true)}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <div className="input-group input-group-sm mb-1 col-md-6">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Código Segun Ordenanza:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={body.ordenanza}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-12 d-flex justify-content-bettween p-0 m-0">
              <div className="input-group input-group-sm mb-1 col-md-12">
                <div className="input-group input-group-sm mb-1 col-md-12">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Descripcion
                  </span>
                  <textarea
                    type="textarea"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={body.descripcion}
                    style={{ height: 65 }}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 d-flex justify-content-bettween p-0 m-0">
              <div className="input-group input-group-sm mb-1  col-md-12">
                <div className="input-group input-group-sm mb-1  col-md-12">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Concepto
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={body.concepto}
                    disabled={props.operacion === 4 || props.operacion === 2}
                    onChange={(e) => {
                      const { value } = e.target;
                      setBody((prev) => ({
                        ...prev,
                        concepto: value,
                      }));
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 d-flex justify-content-bettween p-0 m-0">
              <div className="input-group input-group-sm mb-1  col-md-12">
                <div className="input-group input-group-sm mb-1  col-md-4">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Fecha
                  </span>
                  <input
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={body.fecha}
                    disabled
                  />
                </div>
                <div className="input-group input-group-sm mb-1  col-md-4">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Valor Unitario
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled
                    value={formatMoneda(
                      body.unitario.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  />
                </div>
                <div className="input-group input-group-sm mb-1  col-md-4">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Valor Total
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled
                    value={formatMoneda(
                      body.total.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-primary col-md-2"
          onClick={() => validarOperacion()}
        >
          <i className="fas fa-check"></i> Aceptar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <CatalogoTipoMulta
        show={showCatalogo}
        onHide={() => setShowCatalogo(false)}
        seleccionarRegistro={seleccionarTipoMulta}
        tipo={tipo}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
}
